/**
 * Portfolio Empty Component
 *
 * Shown when user is not authenticated.
 * NOW THEME-AWARE
 */

import React, { useMemo } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';

export function PortfolioEmpty() {
  const navigation = useNavigation<any>();
  const { theme } = useTheme();
  const { t } = useTranslation();
  const styles = useMemo(() => createThemedStyles(theme), [theme]);

  const handleLogin = () => {
    navigation.navigate('Login');
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.title}>
          {t('portfolio.welcomeToTracker', { defaultValue: 'Welcome to Portfolio Tracker' })}
        </Text>
        <Text style={styles.message}>
          {t('portfolio.welcomeMessage', {
            defaultValue:
              'Track your investment portfolio with ease. Upload your Interactive Brokers CSV files to view positions and trades.',
          })}
        </Text>

        <TouchableOpacity style={styles.button} onPress={handleLogin}>
          <Text style={styles.buttonText}>
            {t('auth.loginToGetStarted', { defaultValue: 'Login to Get Started' })}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity onPress={handleLogin}>
          <Text style={styles.link}>
            {t('auth.dontHaveAccountRegister', { defaultValue: "Don't have an account? Register" })}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

/**
 * Create themed styles dynamically
 */
function createThemedStyles(theme: any) {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.background,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 32,
    },
    content: {
      alignItems: 'center',
      maxWidth: 400,
    },
    title: {
      fontSize: theme.typography.fontSize2Xl,
      fontWeight: theme.typography.fontWeightBold,
      color: theme.colors.text,
      marginBottom: 16,
      textAlign: 'center',
      textTransform: theme.id === 'bauhaus' ? 'uppercase' : 'none',
    },
    message: {
      fontSize: theme.typography.fontSizeMd,
      color: theme.colors.textSecondary,
      textAlign: 'center',
      marginBottom: 32,
      lineHeight: 24,
    },
    button: {
      backgroundColor: theme.colors.primary,
      paddingHorizontal: 32,
      paddingVertical: 12,
      borderRadius: theme.radii.md,
      marginBottom: 16,
      borderWidth: theme.id === 'bauhaus' ? 2 : 0,
      borderColor: theme.colors.border,
    },
    buttonText: {
      color: theme.colors.textInverse,
      fontSize: theme.typography.fontSizeMd,
      fontWeight: theme.typography.fontWeightSemibold,
      textTransform: theme.id === 'bauhaus' ? 'uppercase' : 'none',
    },
    link: {
      color: theme.colors.primary,
      fontSize: theme.typography.fontSizeSm,
    },
  });
}
